module.exports = __webpack_public_path__ + "static/media/data_analyst_use_case_2.c846b2d7.svg";